import React, { useEffect, useState } from "react";
import axiosSetup from "../../utils/axiosSetup";
import { IPincodeData } from "../../models/pincodeData,model";

const PincodeManagement: React.FC = () => {
  const [pincodes, setPincodes] = useState([]);

  const fetchPincodes = async () => {
    try {
      const { data } = await axiosSetup.get("/pincodes");
      setPincodes(data.data);
    } catch (err) {
      console.error("Error fetching pincodes:", err);
    }
  };

  useEffect(() => {
    fetchPincodes();
  }, []);

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">Pincode Management</h2>
      <table className="w-full border">
        <thead>
          <tr>
            <th className="border px-4 py-2">Pincode</th>
            <th className="border px-4 py-2">Count</th>
          </tr>
        </thead>
        <tbody>
          {pincodes.map((pincode: IPincodeData) => (
            <tr
              key={pincode._id}
              className={pincode.count === 1 ? "bg-yellow-100" : ""}
            >
              <td className="border px-4 py-2">{pincode.pincode}</td>
              <td className="border px-4 py-2">{pincode.count}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PincodeManagement;
